export default __webpack_public_path__ + "static/media/REFIN_affrescati_LP_CONF_OMBRA-80x80.55c9a6f3.jpg";